import { Autocomplete, Card, TextField } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import { observer } from 'mobx-react-lite';
import { FC, useCallback, useMemo, useState } from 'react';
import { API } from '~/api';
import { Col } from '../view.box';

export type DashboardCountriesChartProps = {
	countries: API.AnalyticsCountry[];
	height?: number;
};
export const DashboardCountriesChart: FC<DashboardCountriesChartProps> = observer(({ countries, height = 600 }) => {
	const [filters, setFilters] = useState<API.AnalyticsCountry[]>([]);
	const handleChangeFilters = useCallback((_: unknown, value: API.AnalyticsCountry[]) => {
		setFilters(value);
	}, []);

	const dataset = useMemo(() => {
		return countries
			.filter(country => !filters.some(filter => filter.code === country.code))
			.map(country => {
				const item: API.AnalyticsCountry & Record<string, any> = { ...country };
				return item;
			});
	}, [countries, filters]);

	return (
		<Card elevation={2} sx={{ flex: 1 }}>
			<Col p={2}>
				<BarChart
					height={height}
					dataset={dataset}
					layout="horizontal"
					series={[{ dataKey: 'count', label: 'Number of users by country' }]}
					yAxis={[{ scaleType: 'band', dataKey: 'name', tickLabelStyle: { display: 'none' } }]}
				/>
				<Autocomplete
					multiple
					options={countries}
					renderInput={props => <TextField {...props} label="Exclude countries from chart" />}
					getOptionLabel={option => option.name}
					isOptionEqualToValue={(option, value) => option.code === value.code}
					value={filters}
					onChange={handleChangeFilters}
				/>
			</Col>
		</Card>
	);
});
